
import React from "react";
import { UseFormRegister, FieldErrors, UseFormHandleSubmit } from "react-hook-form";
import { Button } from "@/components/ui/button";
import { CourseFormData } from "./types";
import { BasicInfoFields } from "./form-sections/BasicInfoFields";
import { PricingFields } from "./form-sections/PricingFields";
import { DescriptionField } from "./form-sections/DescriptionField";
import { JsonFields } from "./form-sections/JsonFields";

interface CourseFormProps {
  register: UseFormRegister<CourseFormData>;
  errors: FieldErrors<CourseFormData>;
  handleSubmit: UseFormHandleSubmit<CourseFormData>;
  onSubmit: (data: CourseFormData) => Promise<void>;
  isSubmitting?: boolean;
}

export function CourseForm({ register, errors, handleSubmit, onSubmit, isSubmitting }: CourseFormProps) {
  return (
    <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
      <BasicInfoFields register={register} errors={errors} />
      <PricingFields register={register} errors={errors} />
      <DescriptionField register={register} />
      <JsonFields register={register} errors={errors} />
      <Button type="submit" disabled={isSubmitting} className="w-full">
        {isSubmitting ? 'Adding Course...' : 'Add Course'}
      </Button>
    </form>
  );
}
